module.exports = __webpack_public_path__ + "img/empty_offers_1.eea03ade.svg";